export function getCurrentDateMinusDays(daysSubtracted){
	var nowMillis = Date.now()
	var millisFactorPerDay = 24 * 3600 * 1000
	var previousDateMillis = nowMillis - (daysSubtracted * millisFactorPerDay)
	return new Date(previousDateMillis)
}
export function toDateString(date){
	var dateString = ""
	var dayInMonth = date.getDate()
	var twoDigitDate = getTwoDigitValue(dayInMonth)
	dateString = twoDigitDate + "-" + getMonthNames()[date.getMonth()] + "-" + date.getFullYear().toString().substring(2,4)
	return dateString
}
export function getTwoDigitValue(number){
	var twoDigitValue = number
	if(number < 10){
		twoDigitValue = "0"+ number
	}
	return twoDigitValue
}
export function getMonthNames(){
	return ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
}
export function formatDateFromEightDigits(date){
  //incoming format: 2021-10-29
  //outgoing format:  29-OCT-21
  var year = date.substring(2, 4)
  var month = date.substring(5, 7)
  var monthIndex = parseInt(month) - 1

  month = getMonthNames()[monthIndex]
  var day = date.substring(8, 10)

  date = day + "-" + month + "-" + year

  return date
}
export function getFirstDayOfThisMonth(){
	var then =  new Date()
	then.setDate(1)
	then.setHours(0)
	then.setMinutes(0)
	then.setSeconds(0)
	then.setMilliseconds(0)
	return then

}
export function getFirstDayOfThisYear(){
	var then =  new Date()
	then.setMonth(0)
	then.setDate(1)
	then.setHours(0)
	then.setMinutes(0)
	then.setSeconds(0)
	then.setMilliseconds(0)
	return then

}
export function getDateFromString(dateString){
	var date = null
	try{
		//var dt=new Date("2011/11/30");
		var year2Digits = dateString.substring(7, 9)
		var year4Digits = "20" + year2Digits
		var month = dateString.substring(3, 6)
		var monthNames = getMonthNames()

		var monthIndex = 0
		for(let item in monthNames){
			if(monthNames[item] == month){
				monthIndex = item
				break
			}
		}
		monthIndex++

		var day = dateString.substring(0, 2)

		var dateParamString = year4Digits + "/" + month + "/" + day
		date = new Date(dateParamString)

	}catch(error){
		console.log("Encountered error " + error + " trying to generate Date object from string: |" + dateString + "|")
	}

	return date

}
